// ==============================|| LOGO SVG ||============================== //

import logo from 'assets/images/logo.svg';

const Logo = ({ height = 50 }: { height?: number }) => (
    <img src={logo} alt="SilverStay" style={{ display: 'block', height, width: 'auto' }} />
);
export default Logo;
